import { cache } from 'tm3-core/cache';
import { AddBespokePlugins } from 'tm3-core/controls/plugin-util';
import PluginManifest from './plugin-manifest';

const PluginGDS = () => {
  cache.app.plugin(
    () => cache.isGDS,
    () => AddBespokePlugins(PluginManifest)
  );
};

export default PluginGDS;
